/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Kategori sayfası: renk sayısını (2 colours) fiyat satırına taşı
  function moveColourCountIntoPriceRow() {
    if (!document.body.classList.contains('template-collection')) return;

    // product-item__price__holder'ı bul
    document.querySelectorAll('.product-item__price__holder').forEach(function(priceHolder) {
      // Üst container: data-product-information
      var info = priceHolder.closest('[data-product-information]');
      if (!info) return;

      // Renk sayısı span'ini bul (product-item-siblings veya swatches__holder içinde)
      var countSpan = info.querySelector('.product-item__swatches__count');
      if (!countSpan || priceHolder.contains(countSpan)) return;

      // Orijinal holder (product-item-siblings veya swatches__holder)
      var originalHolder = countSpan.closest('product-item-siblings') ||
                           countSpan.closest('.product-item__swatches__holder');

      // Fiyat holder'a taşı
      priceHolder.appendChild(countSpan);

      // Orijinal holder'ı gizle
      if (originalHolder) {
        originalHolder.style.setProperty('display', 'none', 'important');
      }
    });
  }

  // DOM hazır olunca + gecikmeli çalıştır
  function runMoveColour() {
    moveColourCountIntoPriceRow();
    injectViwColourCount();
    setTimeout(function() { moveColourCountIntoPriceRow(); injectViwColourCount(); }, 500);
    setTimeout(function() { moveColourCountIntoPriceRow(); injectViwColourCount(); }, 1500);
  }

  // ===========================================================
  // VIW grup listesi — uygulamayla bağlı renk varyasyonu grupları
  // Yeni grup veya yeni renk eklediğinde buraya handle ekleyin.
  // Handle = URL'deki /products/ sonrası kısım.
  // ===========================================================
  var VIW_GROUPS = [
    // Grup 1 — Premium Sheer Jeans
    [
      'the-premium-sheer-jeans-tint',
      'the-premium-sheer-jeans-charcoal',
      'the-premium-sheer-jeans-taupe'
    ],
    // Grup 2 — Classic Mid Rise Jeans
    [
      'classic-black-mid-rise-jeans',
      'classic-dark-blue-mid-rise-jeans-copy',
      'classic-blue-mid-rise-jeans',
      'classic-light-blue-mid-rise-jeans'
    ],
    // Grup 3 — Rose Corset Top
    [
      'rose-corset-top-white',
      'rose-corset-top-black'
    ],
    // Grup 4 — Mid Rise Straight Fit Jeans
    [
      'mid-rise-straight-fit-jeans-blue',
      'mid-rise-straight-fit-jeans-gray',
      'mid-rise-straight-fit-jeans-light-blue'
    ]
  ];

  // Handle → grup büyüklüğü lookup'ı
  var VIW_HANDLE_TO_COUNT = {};
  VIW_GROUPS.forEach(function(group) {
    group.forEach(function(handle) {
      VIW_HANDLE_TO_COUNT[handle] = group.length;
    });
  });

  // Kategori sayfasındaki VIW ürünlerine "X colors" yazısı ekle
  function injectViwColourCount() {
    if (!document.body.classList.contains('template-collection')) return;

    document.querySelectorAll('grid-item, .product-item').forEach(function(card) {
      // Handle'ı data-url'den veya product linkinden çıkar
      var url = card.getAttribute('data-url') || '';
      if (!url) {
        var link = card.querySelector('a[href*="/products/"]');
        if (link) url = link.getAttribute('href') || '';
      }
      var m = url.match(/\/products\/([^/?#]+)/);
      if (!m) return;

      var handle = m[1];
      var count = VIW_HANDLE_TO_COUNT[handle];
      if (!count) return; // VIW grubunda değilse dokunma

      var priceHolder = card.querySelector('.product-item__price__holder');
      if (!priceHolder) return;

      // Zaten count varsa tekrar ekleme (native veya daha önce eklenmiş)
      if (priceHolder.querySelector('.product-item__swatches__count')) return;

      // Temanın native yapısıyla birebir aynı HTML
      var countSpan = document.createElement('span');
      countSpan.className = 'product-item__swatches__count viw-injected-count';
      var innerSpan = document.createElement('span');
      innerSpan.setAttribute('data-sibling-count', '');
      innerSpan.textContent = count + ' colors';
      countSpan.appendChild(innerSpan);
      priceHolder.appendChild(countSpan);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runMoveColour);
  } else {
    runMoveColour();
  }

  // Ajaxinate (infinite scroll) sonrası da çalıştır
  document.addEventListener('ajaxinate:updated', function() {
    moveColourCountIntoPriceRow();
    injectViwColourCount();
  });

  // MutationObserver: filtre / sayfalama / quick view vb. ile yeni ürünler
  // DOM'a eklendiğinde otomatik yakala
  if (document.body.classList.contains('template-collection')) {
    var debounceTimer = null;
    var mo = new MutationObserver(function(mutations) {
      var shouldRun = false;
      for (var i = 0; i < mutations.length; i++) {
        var addedNodes = mutations[i].addedNodes;
        for (var j = 0; j < addedNodes.length; j++) {
          var node = addedNodes[j];
          if (node.nodeType === 1 && (
              node.matches && (node.matches('grid-item') || node.matches('.product-item')) ||
              node.querySelector && node.querySelector('.product-item__price__holder'))) {
            shouldRun = true;
            break;
          }
        }
        if (shouldRun) break;
      }
      if (shouldRun) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function() {
          moveColourCountIntoPriceRow();
          injectViwColourCount();
        }, 50);
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

// ============================================================
// VIW FIX v13: Rio render'ını olduğu gibi bırak, sadece size chart yönet
// - Rio kendi beden kutucuklarını göstersin (dropdown'a ÇEVİRMİYORUZ)
// - Rio tespit edilirse standalone-size-chart-link'i göster, uygun yere taşı
// - Rio yoksa hiçbir şey yapma (normal ürünler temanın kendi size chart'ını gösterir)
// ============================================================
(function () {

  var OPTION_NAME = 'Size';

  function initVIW() {
    [300, 700, 1200, 2000].forEach(function (t) {
      setTimeout(placeSizeChart, t);
    });

    // Rio sonradan render ettiğinde de tetikle (renk değiştirince)
    var obs = new MutationObserver(function (mutations) {
      var rioChanged = mutations.some(function (m) {
        return Array.from(m.addedNodes).some(function (n) {
          return n.nodeType === 1 &&
            n.className && typeof n.className === 'string' &&
            n.className.indexOf('Pwzr') !== -1;
        });
      });
      if (!rioChanged) return;
      clearTimeout(window._viwTimer);
      window._viwTimer = setTimeout(placeSizeChart, 150);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  function placeSizeChart() {
    // Rio'nun Size container'ı var mı?
    var rioSizeContainer = document.querySelector('[data-option="' + OPTION_NAME + '"]');
    if (!rioSizeContainer) return; // Rio yok → hiçbir şey yapma

    // Rio'nun kendi "Size" başlığını gizle (standalone size chart yerini alacak)
    var rioTitle = document.querySelector('.rio-product-option-title');
    if (rioTitle) rioTitle.style.setProperty('display', 'none', 'important');

    // Standalone size chart linkini bul
    var vs = document.querySelector('variant-selects');
    if (!vs) return;
    var chartWrap = document.querySelector('[data-standalone-size-chart="' + vs.id + '"]');
    if (!chartWrap) return;

    // Görünür yap (varsayılan CSS'i display:none olacak)
    chartWrap.style.setProperty('display', 'block', 'important');

    // Rio size container'ının hemen üstüne taşı (zaten oradaysa dokunma)
    var rioOuter = rioSizeContainer.closest('[class*="rio-width-fit-content"]') || rioSizeContainer;
    if (rioOuter.previousElementSibling !== chartWrap) {
      rioOuter.parentElement.insertBefore(chartWrap, rioOuter);
    }

    console.log('[VIW v13] Size chart yerleştirildi');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVIW);
  } else {
    initVIW();
  }

})();
